import { render, staticRenderFns } from "./worldCompliance.vue?vue&type=template&id=2a12b4d9&scoped=true&"
import script from "./worldCompliance.vue?vue&type=script&lang=js&"
export * from "./worldCompliance.vue?vue&type=script&lang=js&"
import style0 from "./worldCompliance.vue?vue&type=style&index=0&id=2a12b4d9&prod&scoped=true&lang=css&"
import style1 from "./worldCompliance.vue?vue&type=style&index=1&id=2a12b4d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a12b4d9",
  null
  
)

export default component.exports